import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { defineCustomElements } from '@uoa/web-components/loader';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CognitoConfigService, StorageService, AuthModule } from '@uoa/auth';
import { AppAuthConfigService, AppStorageService } from './app/core/services';
import { UoaErrorsConfig, ErrorToastService, provideErrorPages } from '@uoa/error-pages';
import { AppErrorsConfig } from './app/core/services/app-errors-config.service';
import { AppToastService } from './app/core/services/app-toast.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ApplicationRoutes } from './app/app.routing';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app/app.component';
import { provideIonicAngular } from '@ionic/angular/standalone';

if (environment.production) {
  enableProdMode();
}

defineCustomElements();

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
          BrowserModule,
          AuthModule,
          IonicStorageModule.forRoot(),
          IonicModule.forRoot(),
        ),
        provideErrorPages(),
        provideRouter(ApplicationRoutes),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: CognitoConfigService, useClass: AppAuthConfigService },
        { provide: StorageService, useClass: AppStorageService },
        { provide: UoaErrorsConfig, useClass: AppErrorsConfig },
        { provide: ErrorToastService, useClass: AppToastService },
        provideHttpClient(withInterceptorsFromDi()),
        provideIonicAngular({
          animated: false,
          innerHTMLTemplatesEnabled: true
        })
    ]
})
.catch((err) => {
  // eslint-disable-next-line no-console
  console.log(err);
});